import { RestLink } from "apollo-link-rest";
import {
  ApolloClient,
  ApolloLink,
  ApolloProvider,
  InMemoryCache,
} from "@apollo/client";
import { getTokenInfo } from "contexts/AuthManager/Auth";
import { DEFAULT_OPTIONS } from "./providerUtils";
import { setContext } from "@apollo/client/link/context";

// -----------------------------------------------------
const patchIfExists = (
  data: any,
  key: string,
  __typename: string,
  patcher: RestLink.FunctionalTypePatcher
) => {
  const value = data[key];
  if (value == null) {
    return {};
  }
  return { [key]: patcher(value, __typename, patcher) };
};

const commonPatch = (
  obj: any,
  outerType: string,
  patchDeeper: RestLink.FunctionalTypePatcher
) => {
  if (obj == null) {
    return obj;
  }

  return {
    ...obj,
    ...patchIfExists(obj, "details", "Details", patchDeeper),
  };
};

const typePatcher: RestLink.TypePatcherTable = {
  Rollups: commonPatch,
  Rollup: commonPatch,
  Summary: commonPatch,
  ProcessHierarchy: commonPatch,
};

const customFetch: RestLink.CustomFetch = (url, options) => {
  if (options.credentials === null) {
    delete options.credentials;
  }
  return fetch(url, options);
};
export const MACHEMETRY_URL = "https://api.raventelemetry.com/";
const restLink = new RestLink({
  // uri: "https://fledge.raventelemetry.com/",
  uri: MACHEMETRY_URL,
  // uri: 'http://localhost/',
  typePatcher,
  customFetch,
});

// End of link-rest, more is scattered throughout
// -----------------------------------------------------

const machemetryAuthLink = setContext((_, { headers }) => {
  // Get the id token from local storage if it exists
  const { idToken } = getTokenInfo();

  // TECHDEBT: machemetry isn't set up to accept "trace-flags" in Access-Control-Allow-Headers
  // const shouldAddTracingHeader = getShouldAddTracingHeaderToRequests();

  // Return the headers to the context so httpLink can read them
  return {
    headers: {
      // Trying something to see if this is the issue with Edge
      ...(headers ? headers : {}),
      authorization: idToken ? `Bearer ${idToken}` : "no-token",
      // ...(shouldAddTracingHeaders ? TRACING_HEADERS : {})
    },
  };
});

// Configure the ApolloClient with the recommended cache and our RestLink
export const machemetryClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: ApolloLink.from([machemetryAuthLink.concat(restLink)]),
  defaultOptions: DEFAULT_OPTIONS,
  connectToDevTools: process.env.NODE_ENV === "development",
});

const MachemetryProvider = (props: { children: React.ReactNode }) => (
  <ApolloProvider client={machemetryClient}>{props.children}</ApolloProvider>
);

export default MachemetryProvider;
